export const CATEGORIES = [
  { title: 'Art', id: 25, color: '#ef9a9a', icon: '🎨' },
  { title: 'Maths', id: 19, color: '#f48fb1', icon: '🔢' },
  { title: 'Sports', id: 21, color: '#CE93D8', icon: '⚽' },
  { title: 'Science & Nature', id: 17, color: '#9575cd', icon: '🌲' },
  { title: 'Celebrities', id: 26, color: '#90caf9', icon: '💅' },
  { title: 'Vehicles', id: 28, color: '#4db6ac', icon: '🚗' },
  { title: 'Computers', id: 18, color: '#81c784', icon: '💻' },
  { title: 'Comics', id: 29, color: '#ffd54f', icon: '😎' },
  { title: 'Video Games', id: 15, color: '#aed581', icon: '🎮' },
  { title: 'Animals', id: 27, color: '#a1887f', icon: '🐶' },
  { title: 'Cartoon & Animations', id: 32, color: '#ff8a65', icon: '👾' },
  { title: 'History', id: 23, color: '#90a4ae', icon: '📚' },
  { title: 'General Knowledge', id: 9, color: '#7986cb', icon: '🔮' },
  { title: 'Geography', id: 22, color: '#a4d7e1', icon: '🌍' },
  { title: 'Mythology', id: 20, color: '#f0dab1', icon: '🐉' }
]

export const MEMES = {
  smart: [ '01.jpg', '02.jpg', '03.jpg', '04.jpg', '05.jpg',
    '06.jpg', '07.jpeg', '08.jpg', '09.jpg', '10.jpg' ],

  dull: [ '01.jpg', '02.jpg', '03.jpg', '04.jpg', '05.jpg',
    '06.jpg', '07.jpg', '08.jpg', '09.jpg', '10.jpg']
}
